import React from "react"
import Link from "gatsby-link"
import style from "./footer.module.css";
import facebook from "../../assets/facebook.svg"
import linkedin from "../../assets/linkedin.svg"

export default () =>
  <footer id="footer" className={style.main}>
    <div className={style.linkList}>
      <div className={style.linkGroup}>
        <a className={style.link} target="_blank" href="mailto:robin@robinvanwechem.nl">robin@robinvanwechem.nl</a>
        <a className={style.link} href="tel:0031619947484">0031 (0)6 19947484</a>
      </div>
      <div className={style.linkGroupIcon}>
        <a className={style.linkIcon} target="_blank" href="https://www.facebook.com/robin.vanwechem"><img className={style.linkImage} src={facebook} width="16" height="16" /></a>
        <a className={style.linkIcon} target="_blank" href="https://nl.linkedin.com/in/robin-van-wechem-744792154"><img className={style.linkImage} src={linkedin} width="16" height="16" /></a>
      </div>
    </div>
  </footer>


// WEBPACK FOOTER //
// ./src/layouts/Footer/Footer.js